import React from 'react';
import ReactSVG from 'react-svg';
import loadingAnimationSvg from '../../images/loading.svg';

export default class LoadingAnimation extends React.Component {
  render () {
    return (
      <div className="c-loading-animation">
        <ReactSVG src={loadingAnimationSvg}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/LoadingAnimation.js